import { render, staticRenderFns } from "./SaleServiceOrderViewItem.vue?vue&type=template&id=4e2a3af8&scoped=true&"
import script from "./SaleServiceOrderViewItem.vue?vue&type=script&lang=js&"
export * from "./SaleServiceOrderViewItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleServiceOrderViewItem.vue?vue&type=style&index=0&id=4e2a3af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2a3af8",
  null
  
)

export default component.exports